'use client';

import * as React from 'react';
import { cn } from '@/lib/utils';
import { Switch as SwitchPrimitive } from 'radix-ui';

function Switch({
  className,
  size = 'default',
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root> & {
  size?: 'sm' | 'default';
}) {
  return (
    <SwitchPrimitive.Root
      data-slot='switch'
      data-size={size}
      className={cn(
        'peer group/switch inline-flex shrink-0 items-center rounded-full p-[2px] shadow-xs transition-all outline-none focus-visible:ring-[3px] focus-visible:ring-brand-ring/50 disabled:cursor-not-allowed disabled:opacity-50 data-[size=default]:h-[22px] data-[size=default]:w-9 md:data-[size=default]:h-5 md:data-[size=default]:w-8 data-[size=sm]:h-3.5 data-[size=sm]:w-6 data-[state=checked]:bg-brand-primary data-[state=unchecked]:bg-brand-input',
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot='switch-thumb'
        className={cn(
          'pointer-events-none block rounded-full bg-brand-background shadow-sm ring-0 transition-transform group-data-[size=default]/switch:size-[18px] md:group-data-[size=default]/switch:size-4 group-data-[size=sm]/switch:size-2.5 data-[state=unchecked]:translate-x-0 group-data-[size=default]/switch:data-[state=checked]:translate-x-3.5 md:group-data-[size=default]/switch:data-[state=checked]:translate-x-3 group-data-[size=sm]/switch:data-[state=checked]:translate-x-2.5 rtl:group-data-[size=default]/switch:data-[state=checked]:-translate-x-3.5 md:rtl:group-data-[size=default]/switch:data-[state=checked]:-translate-x-3 rtl:group-data-[size=sm]/switch:data-[state=checked]:-translate-x-2.5',
        )}
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };
